import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Functional } from 'vms-base';
import s from './MapNoteFilter.module.scss';

const MapNoteFilterInfo = props => {
    const statusLabel = Functional.capitalizeFirst(props.status);
    return (
        <div className={s.infoWrapper}>
            <button className={classNames(s.filterInfo, s.removeButtonStyling, props.active ? s.active : s.inactive)} onClick={() => props.onClick()} type="button">
                <div className={s.label}>{`${statusLabel} Notes (${props.amount})`}</div>
                <div className={classNames(props.expanded ? 'icon-triangleup' : 'icon-triangledown', s.icon)} />
            </button>
        </div>
    );
};

MapNoteFilterInfo.propTypes = {
    active: PropTypes.bool.isRequired,
    expanded: PropTypes.bool.isRequired,
    amount: PropTypes.number.isRequired,
    status: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
};

export default MapNoteFilterInfo;
